import { Result } from "@cartographerio/fp";
import { isPoint, safePointToNgr, } from "@cartographerio/geometry";
import { hasOptionalKey, isNullable, isObject, isString, } from "@cartographerio/guard";
import { isTimestamp } from "@cartographerio/types";
export function isPartialData(data) {
    return (isObject(data) &&
        hasOptionalKey(data, "recorded", isNullable(isTimestamp)) &&
        hasOptionalKey(data, "location", isNullable(isPoint)) &&
        hasOptionalKey(data, "knowledge", (knowledge) => isObject(knowledge) &&
            hasOptionalKey(knowledge, "localName", isNullable(isString))));
}
const g = Result.guard(isPartialData, "PartialUclPitStop");
export function dataDescription(data) {
    return g(data).map(data => [
        data.knowledge.localName ?? "Unnamed Pond",
        data.location == null ? "Unknown NGR" : safePointToNgr(data.location),
    ].join(", "));
}
export function dataGeometry(data) {
    return g(data).map(data => data.location ?? null);
}
export function dataTimestamp(data) {
    return g(data).map(data => data.recorded ?? null);
}
export function copyData(data) {
    return g(data).map(data => ({
        ...data,
        recorded: null,
    }));
}
//# sourceMappingURL=parts.js.map